/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BondAllocation } from './BondAllocation';
import {
    BondAllocationFromJSON,
    BondAllocationFromJSONTyped,
    BondAllocationToJSON,
} from './BondAllocation';

/**
 * 
 * @export
 * @interface AggregatedBondTrade
 */
export interface AggregatedBondTrade {
    /**
     * 
     * @type {number}
     * @memberof AggregatedBondTrade
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof AggregatedBondTrade
     */
    masterAccount: string;
    /**
     * 
     * @type {string}
     * @memberof AggregatedBondTrade
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof AggregatedBondTrade
     */
    side: string;
    /**
     * 
     * @type {number}
     * @memberof AggregatedBondTrade
     */
    aggregatedQuantity: number;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedBondTrade
     */
    executed: boolean;
    /**
     * 
     * @type {Array<BondAllocation>}
     * @memberof AggregatedBondTrade
     */
    allocations: Array<BondAllocation>;
}

/**
 * Check if a given object implements the AggregatedBondTrade interface.
 */
export function instanceOfAggregatedBondTrade(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "masterAccount" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "aggregatedQuantity" in value;
    isInstance = isInstance && "executed" in value;
    isInstance = isInstance && "allocations" in value;

    return isInstance;
}

export function AggregatedBondTradeFromJSON(json: any): AggregatedBondTrade {
    return AggregatedBondTradeFromJSONTyped(json, false);
}

export function AggregatedBondTradeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregatedBondTrade {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optimizationId': json['optimization_id'],
        'masterAccount': json['master_account'],
        'symbol': json['symbol'],
        'side': json['side'],
        'aggregatedQuantity': json['aggregated_quantity'],
        'executed': json['executed'],
        'allocations': ((json['allocations'] as Array<any>).map(BondAllocationFromJSON)),
    };
}

export function AggregatedBondTradeToJSON(value?: AggregatedBondTrade | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optimization_id': value.optimizationId,
        'master_account': value.masterAccount,
        'symbol': value.symbol,
        'side': value.side,
        'aggregated_quantity': value.aggregatedQuantity,
        'executed': value.executed,
        'allocations': ((value.allocations as Array<any>).map(BondAllocationToJSON)),
    };
}

